import {startNewForm} from '../actions/screen';
import {showHelp} from '../common/helpPopover';
import {Column} from '../../../stores/Form/Column';

export function patchColumnHelpContent(text: string) {
    const regex = /^[\s\S]*?\n\n/g;
    const match = text.match(regex);
    if (!match) return text;

    const replacement = ''.padStart(match[0].length, ' ');
    text = text.replace(match[0], replacement);

    return text;
}

export type Params = {
    anchor: HTMLElement;
    column?: Column;
    onLinkClick?: (arg: {eName: string}) => void;
};

export const showFormFieldHelp = async ({anchor, column, onLinkClick}: Params) => {
    const handleOpenScreen = async (obj: {eName: string}) => {
        await startNewForm(obj.eName);
    };

    await showHelp({
        anchor,
        Fname: column.parentForm.ename,
        column,
        onLinkClick: onLinkClick ?? handleOpenScreen
    });
};
